(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[660],{

/***/ 1247:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/qr",
      function () {
        return __webpack_require__(6632);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _internal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4699);
/* harmony import */ var _internal_base_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8312);
/* harmony import */ var _internal_utils_apply_display_name__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1651);
/* harmony import */ var _internal_hooks_use_base_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4656);

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0





var ButtonDropdown = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function(_a, ref) {
    var items = _a.items, _b = _a.variant, variant = _b === void 0 ? "normal" : _b, _c = _a.loading, loading = _c === void 0 ? false : _c, loadingText = _a.loadingText, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.expandableGroups, expandableGroups = _e === void 0 ? false : _e, _f = _a.expandToViewport, expandToViewport = _f === void 0 ? false : _f, ariaLabel = _a.ariaLabel, children = _a.children, onItemClick = _a.onItemClick, onItemFollow = _a.onItemFollow, props = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__rest */ ._T)(_a, [
        "items",
        "variant",
        "loading",
        "loadingText",
        "disabled",
        "expandableGroups",
        "expandToViewport",
        "ariaLabel",
        "children",
        "onItemClick",
        "onItemFollow"
    ]);
    var baseComponentProps = (0,_internal_hooks_use_base_component__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("ButtonDropdown");
    var baseProps = (0,_internal_base_component__WEBPACK_IMPORTED_MODULE_1__/* .getBaseProps */ .j)(props);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, baseProps, baseComponentProps, {
        ref: ref,
        items: items,
        variant: variant,
        loading: loading,
        loadingText: loadingText,
        disabled: disabled,
        expandableGroups: expandableGroups,
        expandToViewport: expandToViewport,
        ariaLabel: ariaLabel,
        onItemClick: onItemClick,
        onItemFollow: onItemFollow
    }), children);
});
(0,_internal_utils_apply_display_name__WEBPACK_IMPORTED_MODULE_5__/* .applyDisplayName */ .b)(ButtonDropdown, "ButtonDropdown");
/* harmony default export */ __webpack_exports__["Z"] = (ButtonDropdown); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 3046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TextContent; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/base-component/index.js + 1 modules
var base_component = __webpack_require__(8312);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/text-content/styles.scoped.css
var styles_scoped = __webpack_require__(713);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/text-content/styles.css.js

/* harmony default export */ var styles_css = ({
    "text-content": "awsui_text-content_6absk_18dc1_94"
});

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/utils/apply-display-name.js
var apply_display_name = __webpack_require__(1651);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-base-component/index.js + 2 modules
var use_base_component = __webpack_require__(4656);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/text-content/index.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0






function TextContent(_a) {
    var children = _a.children, props = (0,tslib_es6/* __rest */._T)(_a, [
        "children"
    ]);
    var __internalRootRef = (0,use_base_component/* default */.Z)("TextContent").__internalRootRef;
    var baseProps = (0,base_component/* getBaseProps */.j)(props);
    var className = (0,clsx_m/* default */.Z)(baseProps.className, styles_css["text-content"]);
    return /*#__PURE__*/ react.createElement("div", (0,tslib_es6/* __assign */.pi)({}, baseProps, {
        className: className,
        ref: __internalRootRef
    }), children);
}
(0,apply_display_name/* applyDisplayName */.b)(TextContent, "TextContent"); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 5546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_textarea; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/base-component/index.js + 1 modules
var base_component = __webpack_require__(8312);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/events/index.js
var events = __webpack_require__(6322);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/context/form-field-context.js
var form_field_context = __webpack_require__(2308);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/forward-focus/index.js
var forward_focus = __webpack_require__(9283);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/textarea/styles.scoped.css
var styles_scoped = __webpack_require__(3786);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/textarea/styles.css.js

/* harmony default export */ var styles_css = ({
    "root": "awsui_root_qk1j1_114w0_93",
    "textarea": "awsui_textarea_qk1j1_114w0_97",
    "textarea-readonly": "awsui_textarea-readonly_qk1j1_114w0_121",
    "textarea-invalid": "awsui_textarea-invalid_qk1j1_114w0_157"
});

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/utils/apply-display-name.js
var apply_display_name = __webpack_require__(1651);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-base-component/index.js + 2 modules
var use_base_component = __webpack_require__(4656);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/input/utils.js
var utils = __webpack_require__(6990);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/textarea/index.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0










var Textarea = /*#__PURE__*/ react.forwardRef(function(_a, ref) {
    var _b;
    var value = _a.value, _c = _a.autoComplete, autoComplete = _c === void 0 ? true : _c, disabled = _a.disabled, readOnly = _a.readOnly, disableBrowserAutocorrect = _a.disableBrowserAutocorrect, disableBrowserSpellcheck = _a.disableBrowserSpellcheck, spellcheck = _a.spellcheck, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onChange = _a.onChange, onBlur = _a.onBlur, onFocus = _a.onFocus, ariaRequired = _a.ariaRequired, name = _a.name, rows = _a.rows, placeholder = _a.placeholder, autoFocus = _a.autoFocus, ariaLabel = _a.ariaLabel, rest = (0,tslib_es6/* __rest */._T)(_a, [
        "value",
        "autoComplete",
        "disabled",
        "readOnly",
        "disableBrowserAutocorrect",
        "disableBrowserSpellcheck",
        "spellcheck",
        "onKeyDown",
        "onKeyUp",
        "onChange",
        "onBlur",
        "onFocus",
        "ariaRequired",
        "name",
        "rows",
        "placeholder",
        "autoFocus",
        "ariaLabel"
    ]);
    var __internalRootRef = (0,use_base_component/* default */.Z)("Textarea").__internalRootRef;
    var _d = (0,form_field_context/* useFormFieldContext */.e)(rest), ariaLabelledby = _d.ariaLabelledby, ariaDescribedby = _d.ariaDescribedby, controlId = _d.controlId, invalid = _d.invalid;
    var baseProps = (0,base_component/* getBaseProps */.j)(rest);
    var textareaRef = (0,react.useRef)(null);
    (0,forward_focus/* default */.Z)(ref, textareaRef);
    var attributes = {
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby,
        "aria-describedby": ariaDescribedby,
        "aria-required": ariaRequired ? "true" : undefined,
        "aria-invalid": invalid ? "true" : undefined,
        name: name,
        placeholder: placeholder,
        autoFocus: autoFocus,
        className: (0,clsx_m/* default */.Z)(styles_css.textarea, (_b = {}, _b[styles_css["textarea-readonly"]] = readOnly, _b[styles_css["textarea-invalid"]] = invalid, _b)),
        autoComplete: (0,utils/* convertAutoComplete */.q)(autoComplete),
        spellCheck: spellcheck,
        disabled: disabled,
        readOnly: readOnly ? true : undefined,
        rows: rows || 3,
        onKeyDown: onKeyDown && function(event) {
            return (0,events/* fireKeyboardEvent */.nm)(onKeyDown, event);
        },
        onKeyUp: onKeyUp && function(event) {
            return (0,events/* fireKeyboardEvent */.nm)(onKeyUp, event);
        },
        // We set a default value on the component in order to force it into the controlled mode.
        value: value || "",
        onChange: onChange && function(event) {
            return (0,events/* fireNonCancelableEvent */.B4)(onChange, {
                value: event.target.value
            });
        },
        onBlur: onBlur && function() {
            return (0,events/* fireNonCancelableEvent */.B4)(onBlur);
        },
        onFocus: onFocus && function() {
            return (0,events/* fireNonCancelableEvent */.B4)(onFocus);
        }
    };
    if (disableBrowserAutocorrect) {
        attributes.autoCorrect = "off";
        attributes.autoCapitalize = "off";
    }
    if (disableBrowserSpellcheck) {
        attributes.spellCheck = "false";
    }
    return /*#__PURE__*/ react.createElement("span", (0,tslib_es6/* __assign */.pi)({}, baseProps, {
        className: (0,clsx_m/* default */.Z)(styles_css.root, baseProps.className),
        ref: __internalRootRef
    }), /*#__PURE__*/ react.createElement("textarea", (0,tslib_es6/* __assign */.pi)({
        ref: textareaRef,
        id: controlId
    }, attributes)));
});
(0,apply_display_name/* applyDisplayName */.b)(Textarea, "Textarea");
/* harmony default export */ var components_textarea = (Textarea); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 6632:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ Page; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_TopNavigation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4210);
/* harmony import */ var _cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1753);
/* harmony import */ var _cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9618);
/* harmony import */ var _cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1993);
/* harmony import */ var _cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2646);
/* harmony import */ var _cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1902);
/* harmony import */ var _cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1456);
/* harmony import */ var _cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9684);
/* harmony import */ var _cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(5546);
/* harmony import */ var _cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(7140);
/* harmony import */ var _cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(3046);
/* harmony import */ var _cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(4977);
/* harmony import */ var _components_Navigation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5794);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_qr_code__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1653);








var CopyStatus;
(function(CopyStatus) {
    CopyStatus["READY"] = "Copy";
    CopyStatus["COPYING"] = "Copying";
    CopyStatus["COPIED"] = "Copied";
})(CopyStatus || (CopyStatus = {}));
function Breadcrumbs() {
    const breadcrumbItems = [
        {
            text: "Home",
            href: "/"
        },
        {
            text: "QR Code Generator",
            href: "/qr"
        }
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        items: breadcrumbItems,
        expandAriaLabel: "Show path",
        ariaLabel: "Breadcrumbs"
    });
}
var __N_SSP = true;
function Page() {
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)("");
    const [result, setResult] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)("");
    const [processing, setProcessing] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const [error, setError] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)("");
    const runProcess = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)((data)=>{
        setResult(data);
        setProcessing(false);
    }, [
        value
    ]);
    const setValueDebounce = (0,lodash__WEBPACK_IMPORTED_MODULE_4__.debounce)((data)=>{
        runProcess(data);
    }, 500);
    const [copyStatus, setCopyStatus] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(CopyStatus.READY);
    const onCopyClicked = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)((text)=>{
        setCopyStatus(CopyStatus.COPYING);
        navigator.clipboard.writeText(text);
        setTimeout(()=>{
            setCopyStatus(CopyStatus.COPIED);
        }, 200);
        setTimeout(()=>{
            setCopyStatus(CopyStatus.READY);
        }, 1000);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TopNavigation__WEBPACK_IMPORTED_MODULE_1__/* .TopNav */ .t, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    header: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        variant: "h1",
                        info: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            variant: "info",
                            ariaLabel: "Information about text converter."
                        }),
                        children: "QR Code Generator"
                    }),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        size: "m",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                size: "m",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        size: "s",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                size: "s",
                                                direction: "horizontal",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                    variant: "h2",
                                                    children: "Input"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                value: value,
                                                onChange: (event)=>{
                                                    setProcessing(true);
                                                    setValue(event.detail.value);
                                                    setValueDebounce(event.detail.value);
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        size: "s",
                                        direction: "horizontal",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                variant: "primary",
                                                iconName: "upload",
                                                onClick: (_)=>runProcess(value),
                                                loading: processing,
                                                children: "Convert"
                                            }),
                                            error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                children: error
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        size: "s",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                size: "s",
                                                direction: "horizontal",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                    variant: "h2",
                                                    children: "Result"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                size: "s",
                                                direction: "horizontal",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_qr_code__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                        value: result
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                        size: "s",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                                    iconName: "download",
                                                                    children: "Save"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                                    items: [
                                                                        {
                                                                            text: "Save as PNG",
                                                                            id: "png"
                                                                        },
                                                                        {
                                                                            text: "Save as JPG",
                                                                            id: "jpg"
                                                                        },
                                                                        {
                                                                            text: "Save as SVG",
                                                                            id: "svg"
                                                                        }
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                size: "s",
                                                direction: "horizontal",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                        readOnly: true,
                                                        value: result
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_themed__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                        iconName: "copy",
                                                        onClick: ()=>onCopyClicked(result),
                                                        loading: copyStatus == CopyStatus.COPYING,
                                                        disabled: copyStatus == CopyStatus.COPIED,
                                                        children: copyStatus
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                }),
                headerSelector: "#header",
                breadcrumbs: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Breadcrumbs, {}),
                navigation: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Navigation__WEBPACK_IMPORTED_MODULE_2__/* .Navigation */ .W, {})
            })
        ]
    });
}


/***/ }),

/***/ 713:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 3786:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [662,996,85,990,808,774,888,179], function() { return __webpack_exec__(1247); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);